import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4qoo1h9y: FaireBrandEntity = {
  token: "b_4qoo1h9y",
  type: "brand",
  name: "Sonder Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/6add3dc98ad8a88c961357978094ebddf8964f1fb411f622c930299f41626d25.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b91dc1c348b87296a98bd66353d81c2fcfaf9cc3dcbbb8d7c65ce8a81be129e6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6add3dc98ad8a88c961357978094ebddf8964f1fb411f622c930299f41626d25.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b91dc1c348b87296a98bd66353d81c2fcfaf9cc3dcbbb8d7c65ce8a81be129e6.jpeg",
  location: "St. Louis, MO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "You’ve probably heard the word sonder by now, but you might not know what it means.\nIt’s “the realization that each random passerby is living a life as vivid and complex as your own.”\nWhich, really, just means empathy.\nThat’s something I strive for in myself and something I want Sonder Goods to embody.\nI'm Jess - my husband, Matt and I live in St. louis with our two boys, Finn and Colin. Our days outside of work include youth sports, family adventures, and soaking in the slower moments when we can.\n\nAt Sonder, we believe scent is storytelling. Each fragrance is crafted to feel grounded, intentional, and quietly expressive—never overwhelming, always inviting. Our blends are designed to evoke the small, meaningful moments that make up a life: the warmth of worn-in spaces, the calm of nature, the comfort of simple routines.\n\nWe work with clean, balanced fragrance oils that honor the character of real botanicals, woods, and resins. Every scent begins with a feeling—earth under bare feet, sun-warmed wood, the softness of a slow morning—and is layered into a blend that feels familiar yet entirely its own.\n\nOur fragrances are:\nEarthy, natural, and warm, with notes that feel lived-in rather than perfumed\nThoughtfully blended to burn softly and make a space feel like home\nInspired by slow living, intentional spaces, and the beauty found in everyday moments",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:20.951Z",
    importedBy: "entity-db-cli",
  },
};
